/* eslint-disable react/no-multi-comp */
import React, {Component} from 'react';
import moment from 'moment';
import strings from 'utils/strings';

import {updateObject} from 'utils/reducerUtils';
const InfoRow = (props) => {
	// eslint-disable-next-line no-undefined
	if (props.condition !== undefined && !props.condition) {
		return null;
	}
	return (
		<p className="info__row">
			<span className="info__label">{props.name}</span>
			<span className="info__value">{props.children || props.value}</span>
		</p>
	);
};
class TestUserInfo extends Component {
	constructor() {
		super();
		this.state = {
			isAddingAnnomnese: false,
			testCandidate: null,
		};
		this.handleUpdateTestCandidateEvent =
			this.handleUpdateTestCandidateEvent.bind(this);
	}
	handleUpdateTestCandidateEvent = (event) => {
		const target = event.target;

		const key = target.name;
		const value = target.value;

		this.handleUpdate(key, value);
	};

	handleUpdate = (key, value) => {
		const {testCandidate} = this.state;
		this.setState({
			testCandidate: updateObject(testCandidate, {
				[key]: value,
			}),
		});
	};
	saveTestCandidate(testCandidateUpdates) {
		const testKey = this.props.testResult.key;
		const testUserId = this.props.testResult.testUserId;

		const obj = {
			info: testCandidateUpdates,
			testUser: testUserId,
			testKey: testKey,
		};

		this.props.onUpdateTestCandidateInfo(obj);
	}
	render() {
		const {testResult} = this.props;
		const {info} = testResult;
		const {testUser} = testResult;
		const isTestOwner = testResult.isTestOwner;

		let completeName = '<skjult navn>';

		if (testUser.firstName) {
			completeName = `${testUser.firstName} ${testUser.lastName}`;
		}

		return (
			<div>
				{isTestOwner && (
					<div className="lit-input-information">
						<button
							className="lit-btn bg-primary"
							onClick={(e) => {
								const candidateObj = {
									firstName: testUser.firstName,
									lastName: testUser.lastName,
									class: info.class || testUser.class || null,
									ageGroup: info.class,
									age: info.age,
									gender: testUser.gender || 'm',
									languagesInHome:
										testUser.languagesInHome || 'one',
								};

								this.setState({
									isAddingAnnomnese:
										!this.state.isAddingAnnomnese,
									testCandidate: candidateObj,
								});
							}}
						>
							{!this.state.isAddingAnnomnese
								? strings.createCandidateInfo
								: strings.cancel}
						</button>
					</div>
				)}
				{this.state.isAddingAnnomnese && (
					<div>
						<form
							className="register-form"
							onSubmit={(event) => {
								event.preventDefault();
								const testCandidate = updateObject(
									this.state.testCandidate
								);

								this.saveTestCandidate(testCandidate);
							}}
						>
							<br />

							<div className="lit-input inline">
								<label
									className="lit-input__label wide"
									htmlFor="test-candidate-modal-firstName"
								>
									{strings.firstname}
								</label>
								<input
									className="lit-input__field"
									id="test-candidate-modal-firstName"
									name="firstName"
									onChange={
										this.handleUpdateTestCandidateEvent
									}
									placeholder="Nordmann"
									type="text"
									value={this.state.testCandidate.firstName}
									required
								/>
							</div>
							<div className="lit-input inline">
								<label
									className="lit-input__label wide"
									htmlFor="test-candidate-modal-lastName"
								>
									{strings.lastname}
								</label>
								<input
									className="lit-input__field"
									id="test-candidate-modal-lastName"
									name="lastName"
									onChange={
										this.handleUpdateTestCandidateEvent
									}
									placeholder="Nordmann"
									type="text"
									value={this.state.testCandidate.lastName}
									required
								/>
							</div>
							<div className="lit-input inline">
								<label
									className="lit-input__label wide"
									htmlFor="test-candidate-modal-age"
								>
									{strings.age}
								</label>
								<input
									className="lit-input__field"
									id="test-candidate-modal-age"
									name="age"
									onChange={
										this.handleUpdateTestCandidateEvent
									}
									placeholder={info.age}
									type="text"
									value={this.state.testCandidate.age}
									required
								/>
							</div>
							<div className="lit-input inline">
								<label
									className="lit-input__label wide"
									htmlFor="test-candidate-modal-gender"
								>
									{strings.sex}
								</label>
								<select
									className="lit-input__field"
									id="test-candidate-modal-gender"
									name="gender"
									onChange={
										this.handleUpdateTestCandidateEvent
									}
								>
									<option key={1} value={'m'}>
										{strings.male}
									</option>
									<option key={2} value={'f'}>
										{strings.female}
									</option>
									<option key={3} value={'u'}>
										{strings.unspecified}
									</option>
								</select>
							</div>
							<div className="lit-input inline">
								<label
									className="lit-input__label wide"
									htmlFor="test-candidate-modal-languagesInHome"
								>
									{strings.grownUpMonoOrBilingual}
								</label>
								<select
									className="lit-input__field"
									id="test-candidate-modal-languagesInHome"
									name="languagesInHome"
									onChange={
										this.handleUpdateTestCandidateEvent
									}
								>
									<option key={1} value={'one'}>
										{strings.oneLanguage}
									</option>
									<option key={2} value={'two'}>
										{strings.twoLanguages}
									</option>
									<option key={3} value={'multiple'}>
										{strings.multipleLanguages}
									</option>
								</select>
							</div>
							<div className="lit-input inline">
								<label
									className="lit-input__label wide"
									htmlFor="test-candidate-modal-class"
								>
									{strings.classGrade}
								</label>
								<input
									className="lit-input__field"
									id="test-candidate-modal-class"
									name="class"
									onChange={
										this.handleUpdateTestCandidateEvent
									}
									placeholder={
										info.class ? (
											info.class
										) : (
											<i>{strings.notavailable}</i>
										)
									}
									type="text"
									value={this.state.testCandidate.class}
									required
								/>
							</div>
							{/* <div className="lit-input inline">
								<label
									className="lit-input__label wide"
									htmlFor="test-admin-modal-phone"
								>
									{strings.telephone}
								</label>
								<input
									className="lit-input__field"
									id="test-admin-modal-phone"
									name="phone"
									onChange={this.handleUpdateTestAdminEvent}
									placeholder="987 65 432"
									required
									type="tel"
									value={testAdmin.phone || ''}
								/>
							</div> */}

							<div className="lit-input">
								<button className="lit-btn bg-primary">
									{`${strings.save}`}
								</button>
							</div>
						</form>
						<br />
					</div>
				)}
				{!this.state.isAddingAnnomnese && (
					<div className="info">
						<InfoRow
							name={strings.testdate}
							value={moment(testResult.completedAt).format('LL')}
						/>
						<InfoRow
							condition={isTestOwner}
							name={strings.name}
							value={completeName}
						/>

						<InfoRow
							name={strings.age}
							value={`${info.age} ${strings.yearsOld}`}
						/>
						<InfoRow name={strings.sex}>
							{testUser.gender === 'm' &&
								(testUser.age.years < 18
									? strings.boy
									: strings.male)}
							{testUser.gender === 'f' &&
								(testUser.age.years < 18
									? strings.girl
									: strings.female)}
							{testUser.gender === 'u' && strings.unspecified}
							{!testUser.gender && <i>{strings.notavailable}</i>}
						</InfoRow>

						<div className="info__group info__group--education">
							<h3>{strings.education}</h3>
						</div>
						<InfoRow name={strings.classGradeColon}>
							{info.class === 0 && strings.lastYearBeforeSchool}
							{info.class === 1 && strings.grade1}
							{info.class === 2 && strings.grade2}
							{info.class === 3 && strings.grade3}
							{info.class === 4 && strings.grade4}
							{info.class === 5 && strings.grade5}
							{info.class === 6 && strings.grade6}
							{info.class === 7 && strings.grade7}
							{info.class === 8 && strings.grade8}
							{info.class === 9 && strings.grade9}
							{info.class === 10 && strings.grade10}

							{testUser.class === 'studiespesialisering' &&
								strings.studyPreparation}
							{testUser.class === 'yrkesfag' && strings.vocational}
							{testUser.class === 'bachelor' && strings.bachelor}
							{testUser.class === 'master' && strings.masterDegree}
							{testUser.class === 'phd' && strings.phdDegree}
						</InfoRow>

						<div className="info__group">
							<h3>{strings.homeLanugage}</h3>
							<InfoRow
								name={strings.grownUpMonoOrBilingual}
							>
								{testUser.languagesInHome === 'one' &&
									strings.oneLanguage}
								{testUser.languagesInHome === 'two' &&
									strings.twoLanguages}
								{testUser.languagesInHome === 'multiple' &&
									strings.multipleLanguages}
								{!testUser.languagesInHome && (
									<i>{strings.notavailable}</i>
								)}
							</InfoRow>
						</div>
					</div>
				)}
			</div>
		);
	}
}

export default TestUserInfo;
